import { render, staticRenderFns } from "./MapCompetitionPoint.vue?vue&type=template&id=1aa8ab36&"
import script from "./MapCompetitionPoint.vue?vue&type=script&lang=js&"
export * from "./MapCompetitionPoint.vue?vue&type=script&lang=js&"
import style0 from "./MapCompetitionPoint.vue?vue&type=style&index=0&id=1aa8ab36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports